"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const react_1 = __importDefault(require("react"));
const Base_1 = require("../Base");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faMagnifyingGlass_1 = require("@fortawesome/free-solid-svg-icons/faMagnifyingGlass");
const Search = ({ ...props }) => {
    return react_1.default.createElement(Base_1.Base, { type: 'search', rightElement: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faMagnifyingGlass_1.faMagnifyingGlass }), ...props });
};
exports.Search = Search;
